import { Extension } from "../../core/extension";
import { popupsEnabledPlugin } from "./popups-enabled-plugin";
/**
 * Adds a plugin to manage an `enabled` state for editor popups, which is true when editor is focused OR focus
 * is within any of editor's popups
 */
export class PopupExtension extends Extension {
    addPlugins(schema, plugins) {
        return plugins.concat([popupsEnabledPlugin(".editor-popup")]);
    }
}
